var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessFulTickCrypto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_9200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0005 0C14.774 0 0 14.7748 0 33C0 51.2252 14.774 66 33.0005 66C51.227 66 66 51.2252 66 33C66 14.7748 51.226 0 33.0005 0ZM52.1984 23.3124L32.428 47.6456C31.7262 48.5099 30.6911 49.035 29.5794 49.0926C29.5117 49.0956 29.4441 49.0976 29.3774 49.0976C28.3374 49.0976 27.3367 48.6856 26.5975 47.9465L14.0733 35.4224C12.5384 33.8876 12.5384 31.3985 14.0733 29.8637C15.6081 28.3288 18.0972 28.3288 19.6321 29.8637L29.0745 39.306L46.0963 18.3554C47.4656 16.6701 49.9405 16.4137 51.6258 17.7829C53.3112 19.1521 53.5666 21.6271 52.1984 23.3124Z",
    fill: "#fcd535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_9200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFulTickCrypto);
export default __webpack_public_path__ + "static/media/successFul-tick-crypto.f17b89c3bc8e5d831e8dc06cdd9dc5c7.svg";
export { ForwardRef as ReactComponent };